<template>
  <div class="td-on-sale-component">
    <p>优惠券金额</p>
    <!--<ul style="padding: 0 10px">-->
    <!--  <li-->
    <!--    v-for="(o, i) in order.coupons"-->
    <!--    :key="i"-->
    <!--  >-->
    <!--    <p>{{o.name}}: 省 <span class="price">{{priceUnit}}{{o.price}}</span></p>-->
    <!--  </li>-->
    <!--</ul>-->
    <span class="price">{{priceUnit}}{{order.couponPrice}}</span>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    priceUnit() {
      return this.order.currency === 'HKD' ? 'HKD ' : '¥'
    }
  }
}
</script>

